import {
  get,
  post,
  put,
  del, patch,
} from '@/utils/request';

const url = 'teachers';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function getTeacherRankList(data) {
  return get({
    url: `${url}/ranks`,
    data,
  });
}

export function getSalaryList(data) {
  return get({
    url: `${url}/salaries`,
    data,
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

export function update(id, data) {
  return put({
    url: `${url}/${id}`,
    data,
  });
}

export function updateTeacherSalaryStage(data) {
  return put({
    url: `${url}/salary-stages`,
    data,
  });
}

export function destroy(id) {
  return del({
    url: `${url}/${id}`,
  });
}

export function restore(id) {
  return post({
    url: `${url}/${id}`,
  });
}

export function getQrCode(id) {
  return patch({
    url: `${url}/${id}/qr-codes`,
  });
}
